/**
 * facett セール価格
 * - facett-price スニペット（data-facett-price-root）対応
 * - 旧 Dawn .price ブロックも JS で変換（price.liquid 未更新時のフォールバック）
 */
(function () {
  var saleProductHandles = null;
  var saleFetchPromise = null;

  function formatMoneyOnly(cents, currencyCodeEnabled) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      var format = currencyCodeEnabled
        ? (Shopify.money_with_currency_format || Shopify.money_format)
        : Shopify.money_format;
      return Shopify.formatMoney(cents, format);
    }
    return '¥' + (cents / 100).toLocaleString('ja-JP');
  }

  var TAX_LABEL = '(税込)';

  function formatTaxHtml() {
    return ' <span class="facett-price__tax fs-5">' + TAX_LABEL + '</span>';
  }

  function stripTaxFromText(text) {
    if (!text) {
      return '';
    }
    return String(text).replace(/[（(]\s*税込\s*[）)]/g, '').replace(/\s+/g, ' ').trim();
  }

  function normalizeTaxLabel(root) {
    if (!root) {
      return;
    }

    root.querySelectorAll('.facett-price__sale-amount, [data-facett-price-compare]').forEach(function (el) {
      el.textContent = stripTaxFromText(el.textContent);
    });

    root.querySelectorAll('[data-facett-price-regular]').forEach(function (el) {
      if (el.querySelector('.facett-price__tax')) {
        el.childNodes.forEach(function (node) {
          if (node.nodeType === 3) {
            node.textContent = stripTaxFromText(node.textContent);
          }
        });
      }
    });

    root.querySelectorAll('.facett-price__sale-line, [data-facett-price-sale].facett-price__sale-line').forEach(function (line) {
      var taxes = line.querySelectorAll('.facett-price__tax, .facett-price__sale-tax');
      for (var i = 1; i < taxes.length; i++) {
        taxes[i].remove();
      }
      if (taxes[0]) {
        taxes[0].textContent = TAX_LABEL;
        if (!taxes[0].classList.contains('facett-price__sale-tax')) {
          taxes[0].classList.add('facett-price__sale-tax');
        }
      }
    });

    root.querySelectorAll('.facett-price__compare-row .facett-price__tax').forEach(function (el) {
      el.textContent = TAX_LABEL;
    });

    root.querySelectorAll('[data-facett-price-regular] .facett-price__tax').forEach(function (el) {
      el.textContent = TAX_LABEL;
    });
  }

  function normalizeAllTaxLabels() {
    document.querySelectorAll('[data-facett-price-root], .card .price, .price.price--card').forEach(function (root) {
      normalizeTaxLabel(root);
    });
  }

  function formatCompareHtml(cents, currencyCodeEnabled) {
    return formatMoneyOnly(cents, currencyCodeEnabled);
  }

  function isCardPrice(root) {
    return !!(root && (root.classList.contains('price--card') || root.closest('.card, .card-wrapper')));
  }

  function formatSaleLineHtml(cents, currencyCodeEnabled, withTax, root) {
    var money = formatMoneyOnly(cents, currencyCodeEnabled);
    if (withTax !== false) {
      return '<span class="facett-price__sale-amount">' + money + '</span> ' +
        '<span class="facett-price__sale-tax">' + TAX_LABEL + '</span>';
    }
    return money + formatTaxHtml();
  }

  function getBadgeText(cfg) {
    if (cfg.percent) {
      return cfg.percent + '%OFF';
    }
    return '';
  }

  function removeSaleBadges(root) {
    root.querySelectorAll('.price__badge-sale, .facett-price__badge').forEach(function (el) {
      el.remove();
    });
  }

  function getOffBadgeParent(root) {
    var saleLine = root.querySelector('.facett-price__sale-line');
    if (saleLine) {
      return saleLine;
    }
    var saleRow = root.querySelector('.facett-price__sale-row');
    if (saleRow) {
      return saleRow;
    }
    return root.querySelector('.price__sale');
  }

  function ensureOffBadge(root, cfg) {
    var text = getBadgeText(cfg);
    if (!text) {
      return;
    }

    var parent = getOffBadgeParent(root);
    if (!parent) {
      return;
    }

    var saleBlock = root.querySelector('.price__sale');
    var badge = saleBlock && saleBlock.querySelector('.facett-price__off-badge');
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'facett-price__off-badge';
      parent.appendChild(badge);
    } else if (badge.parentElement !== parent) {
      parent.appendChild(badge);
    }
    badge.textContent = text;
  }

  function getCompareTarget(root) {
    return root.querySelector('[data-facett-price-compare]');
  }

  function ensureTaxNote(root) {
    var row = root.querySelector('.facett-price__compare-row');
    if (!row) {
      return null;
    }
    var tax = row.querySelector('.facett-price__tax');
    if (!tax) {
      tax = document.createElement('span');
      tax.className = 'facett-price__tax fs-5';
      tax.textContent = TAX_LABEL;
      row.appendChild(tax);
    }
    return tax;
  }

  function isProductSaleEligible(root, handles) {
    handles = handles || saleProductHandles || [];
    if (root.dataset.facettInSale === 'true') {
      return true;
    }
    var handle = root.dataset.facettProductHandle || getProductHandleFromCard(root) || getProductHandleFromPage();
    if (handle && handles.indexOf(handle) >= 0) {
      return true;
    }
    return false;
  }

  function isSaleEligible(root, cfg) {
    if (!root || !cfg || !cfg.active || Number(cfg.percent) <= 0) {
      return false;
    }
    return isProductSaleEligible(root);
  }

  function getProductPriceRoots() {
    var roots = Array.prototype.slice.call(
      document.querySelectorAll('[data-facett-price-root], .facett-sale-enhanced.price--large, product-info .price.price--large, .product .price.price--large')
    );

    return roots.filter(function (root, index) {
      return roots.indexOf(root) === index && !shouldSkipRoot(root);
    });
  }

  function restoreSaleEligibility(root, cfg) {
    var pageHandle = getProductHandleFromPage();
    if (!root || !cfg || !cfg.active) {
      return;
    }

    if (root.dataset.facettInSale === 'true' ||
      root.getAttribute('data-sale-active') === 'true' ||
      root.dataset.saleActive === 'true') {
      return;
    }

    if (pageHandle && saleProductHandles && saleProductHandles.indexOf(pageHandle) >= 0) {
      root.dataset.facettInSale = 'true';
      root.dataset.facettProductHandle = pageHandle;
      root.setAttribute('data-facett-price-root', '');
      root.setAttribute('data-sale-active', 'true');
      if (!root.dataset.salePercent) {
        root.dataset.salePercent = String(cfg.percent);
      }
    }
  }

  function getVariantPrices(root, variantId, variant) {
    var currencyCodeEnabled = root.dataset.currencyCodeEnabled === 'true';
    var priceCents = null;
    var salePriceCents = null;
    var percent = Number(root.dataset.salePercent) || (getConfig() && Number(getConfig().percent)) || 0;

    if (variant && String(variant.id) === String(variantId) && variant.price) {
      priceCents = variant.price;
      salePriceCents = calcSalePrice(variant.price, percent);
    }

    var configEl = root.querySelector('[data-facett-price-variants]');
    if (configEl) {
      try {
        var configText = configEl.tagName === 'TEMPLATE'
          ? configEl.innerHTML
          : configEl.textContent;
        var config = JSON.parse(configText);
        currencyCodeEnabled = !!config.currencyCodeEnabled;
        var row = (config.variants || []).find(function (v) {
          return String(v.id) === String(variantId);
        });
        if (row) {
          priceCents = row.price;
          salePriceCents = row.salePrice;
        }
      } catch (e) {
        /* noop */
      }
    }

    if (!priceCents && window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) {
      var analyticsVariant = (ShopifyAnalytics.meta.product.variants || []).find(function (v) {
        return String(v.id) === String(variantId);
      });
      if (analyticsVariant) {
        priceCents = analyticsVariant.price;
        salePriceCents = calcSalePrice(analyticsVariant.price, percent);
      }
    }

    if (!priceCents) {
      var fromDom = readPriceCentsFromRoot(root);
      if (fromDom) {
        priceCents = fromDom;
        salePriceCents = calcSalePrice(fromDom, percent);
      }
    }

    return {
      priceCents: priceCents,
      salePriceCents: salePriceCents,
      currencyCodeEnabled: currencyCodeEnabled
    };
  }

  function buildSaleBlockInnerHtml(root) {
    return '<div class="facett-price__compare-row">' +
      '<span class="visually-hidden visually-hidden--inline">Regular price</span>' +
      '<s class="price-item price-item--regular facett-price__compare-wrap">' +
      '<span data-facett-price-compare></span></s> ' +
      '<span class="facett-price__tax fs-5">' + TAX_LABEL + '</span></div>' +
      '<div class="facett-price__sale-row">' +
      '<span class="visually-hidden visually-hidden--inline">Sale price</span>' +
      '<span class="price-item price-item--sale price-item--last facett-price__sale-line" data-facett-price-sale>' +
      '<span class="facett-price__sale-amount"></span> <span class="facett-price__sale-tax">' + TAX_LABEL + '</span>' +
      '</span></div>';
  }

  function ensureSaleLayout(root, force) {
    var saleBlock = root.querySelector('.price__sale');
    if (!saleBlock) {
      var container = root.querySelector('.price__container');
      if (!container) {
        return;
      }
      saleBlock = document.createElement('div');
      saleBlock.className = 'price__sale';
      container.appendChild(saleBlock);
    }

    var compareTarget = saleBlock.querySelector('[data-facett-price-compare]');
    var saleTarget = saleBlock.querySelector('[data-facett-price-sale]');
    var hasLayout = !!(saleBlock.querySelector('.facett-price__compare-row') && saleTarget);

    if (hasLayout && !force && compareTarget && saleTarget) {
      return;
    }

    var badge = saleBlock.querySelector('.facett-price__off-badge');
    var badgeText = badge && badge.textContent;
    saleBlock.innerHTML = buildSaleBlockInnerHtml(root);
    if (badgeText) {
      var parent = getOffBadgeParent(root);
      if (parent) {
        var newBadge = document.createElement('span');
        newBadge.className = 'facett-price__off-badge';
        newBadge.textContent = badgeText;
        parent.appendChild(newBadge);
      }
    }
  }

  function needsSaleRefresh(root) {
    if (!isSaleEligible(root, getConfig())) {
      return false;
    }
    if (!root.classList.contains('price--on-sale')) {
      return true;
    }
    if (!root.querySelector('.price__sale')) {
      return true;
    }
    if (!root.querySelector('[data-facett-price-sale]')) {
      return true;
    }
    if (!root.querySelector('.facett-price__compare-row')) {
      return true;
    }
    if (!root.querySelector('.facett-price__off-badge')) {
      return true;
    }
    if (root.querySelector('.price__regular') && getComputedStyle(root.querySelector('.price__regular')).display !== 'none') {
      return true;
    }
    return false;
  }

  function refreshSaleToRoot(root, cfg, variant) {
    restoreSaleEligibility(root, cfg);

    if (!isSaleEligible(root, cfg)) {
      return;
    }

    var variantId = variant && variant.id;
    if (!variantId) {
      return;
    }

    var percent = Number(root.dataset.salePercent) || Number(cfg.percent) || 0;
    if (percent <= 0) {
      return;
    }

    var prices = getVariantPrices(root, variantId, variant);
    if (!prices.priceCents) {
      return;
    }

    var salePrice = prices.salePriceCents || calcSalePrice(prices.priceCents, percent);
    var currencyCodeEnabled = prices.currencyCodeEnabled;
    var forceLayout = !root.classList.contains('price--on-sale') || needsSaleRefresh(root);

    ensureSaleLayout(root, forceLayout);
    var els = ensureSaleElements(root);

    root.classList.add('price--on-sale', 'facett-price', 'facett-sale-enhanced');
    root.setAttribute('data-facett-price-root', '');
    root.dataset.facettInSale = 'true';
    root.dataset.saleActive = 'true';
    root.dataset.salePercent = String(percent);
    root.dataset.facettVariantPrice = String(prices.priceCents);

    var compareTarget = getCompareTarget(root) || els.compareEl;
    if (compareTarget) {
      compareTarget.innerHTML = formatCompareHtml(prices.priceCents, currencyCodeEnabled);
    }
    ensureTaxNote(root);

    if (els.saleEl) {
      els.saleEl.innerHTML = formatSaleLineHtml(salePrice, currencyCodeEnabled, true, root);
    }
    if (els.regularEl) {
      els.regularEl.innerHTML = formatSaleLineHtml(salePrice, currencyCodeEnabled, false, root);
    }

    removeSaleBadges(root);
    ensureOffBadge(root, cfg);
  }

  function refreshAllSalePrices(variant) {
    var cfg = getConfig();
    if (!cfg || !variant || !variant.id) {
      return;
    }

    getProductPriceRoots().forEach(function (root) {
      refreshSaleToRoot(root, cfg, variant);
    });
  }

  function scheduleSaleRefresh(variant) {
    refreshAllSalePrices(variant);
  }

  function getConfig() {
    return window.FACETT_SALE || null;
  }

  function fetchSaleProductHandles(cfg) {
    if (saleProductHandles) {
      return Promise.resolve(saleProductHandles);
    }
    if (saleFetchPromise) {
      return saleFetchPromise;
    }

    saleFetchPromise = fetch('/collections/' + cfg.collectionHandle + '/products.json?limit=250')
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        saleProductHandles = (data.products || []).map(function (p) {
          return p.handle;
        });
        return saleProductHandles;
      })
      .catch(function () {
        saleProductHandles = [];
        return saleProductHandles;
      });

    return saleFetchPromise;
  }

  function calcSalePrice(originalCents, percent) {
    return Math.round(originalCents * (100 - percent) / 100);
  }

  function parseYenTextToCents(text) {
    if (!text) {
      return null;
    }
    var digits = String(text).replace(/[^\d]/g, '');
    if (!digits) {
      return null;
    }
    return parseInt(digits, 10) * 100;
  }

  function getProductHandleFromPage() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function getProductHandleFromCard(root) {
    var card = root.closest('.card') || root.closest('.card-wrapper') || root.closest('.grid__item');
    if (!card) {
      return null;
    }
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) {
      return null;
    }
    var match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function getCurrentVariantPriceCents() {
    var selected = document.querySelector('product-info [data-selected-variant], .product [data-selected-variant]');
    if (selected) {
      try {
        var variant = JSON.parse(selected.textContent);
        if (variant && variant.price) {
          return variant.price;
        }
      } catch (e) {
        /* noop */
      }
    }

    if (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) {
      var variants = ShopifyAnalytics.meta.product.variants || [];
      var idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (idInput) {
        var picked = variants.find(function (v) {
          return String(v.id) === String(idInput.value);
        });
        if (picked) {
          return picked.price;
        }
      }
      var available = variants.find(function (v) {
        return v.available !== false;
      });
      if (available) {
        return available.price;
      }
      if (variants[0]) {
        return variants[0].price;
      }
    }

    return null;
  }

  function readPriceCentsFromRoot(root) {
    var fromData = Number(root.dataset.facettVariantPrice);
    if (fromData) {
      return fromData;
    }
    var regular = root.querySelector('.price__regular .price-item--regular');
    return parseYenTextToCents(regular && regular.textContent);
  }

  function ensureSaleElements(root) {
    root.classList.add('facett-price', 'facett-sale-enhanced');

    var compareEl = root.querySelector('[data-facett-price-compare]');
    if (!compareEl) {
      compareEl = root.querySelector('.price__sale s.price-item--regular');
      if (!compareEl) {
        var saleWrap = root.querySelector('.price__sale span');
        if (saleWrap) {
          compareEl = document.createElement('s');
          compareEl.className = 'price-item price-item--regular';
          saleWrap.innerHTML = '';
          saleWrap.appendChild(compareEl);
        }
      }
      if (compareEl) {
        compareEl.setAttribute('data-facett-price-compare', '');
      }
    }

    var saleEl = root.querySelector('[data-facett-price-sale]');
    if (!saleEl) {
      saleEl = root.querySelector('.price__sale .price-item--sale, .price__sale .price-item--last');
      if (saleEl) {
        var inner = document.createElement('span');
        inner.setAttribute('data-facett-price-sale', '');
        inner.innerHTML = saleEl.innerHTML;
        saleEl.innerHTML = '';
        saleEl.appendChild(inner);
        saleEl = inner;
      }
    }

    var regularEl = root.querySelector('[data-facett-price-regular]');
    if (!regularEl) {
      var regularWrap = root.querySelector('.price__regular .price-item--regular');
      if (regularWrap) {
        regularEl = regularWrap.querySelector('span') || regularWrap;
        regularEl.setAttribute('data-facett-price-regular', '');
      }
    }

    return { compareEl: compareEl, saleEl: saleEl, regularEl: regularEl };
  }

  function applySaleToRoot(root, cfg, options) {
    options = options || {};
    if (!root || root.dataset.saleActive === 'true') {
      return;
    }

    var percent = Number(cfg.percent) || 0;
    if (!cfg.active || percent <= 0) {
      return;
    }

    var handles = options.handles || saleProductHandles || [];
    if (!isProductSaleEligible(root, handles)) {
      return;
    }

    var variantPrice = options.variantPriceCents || readPriceCentsFromRoot(root);
    if (!variantPrice) {
      return;
    }

    var salePrice = calcSalePrice(variantPrice, percent);
    var currencyCodeEnabled = root.dataset.currencyCodeEnabled === 'true';
    var showNote = options.showNote || root.dataset.facettShowNote === 'true';

    ensureSaleLayout(root);
    var els = ensureSaleElements(root);

    root.classList.add('price--on-sale');
    root.setAttribute('data-facett-price-root', '');
    root.dataset.facettInSale = 'true';
    root.dataset.saleActive = 'true';
    root.dataset.salePercent = String(percent);
    root.dataset.facettVariantPrice = String(variantPrice);

    var compareTarget = getCompareTarget(root) || els.compareEl;
    if (compareTarget) {
      compareTarget.innerHTML = formatCompareHtml(variantPrice, currencyCodeEnabled);
    }
    ensureTaxNote(root);

    if (els.saleEl) {
      els.saleEl.innerHTML = formatSaleLineHtml(salePrice, currencyCodeEnabled, true, root);
    }
    if (els.regularEl) {
      els.regularEl.innerHTML = formatSaleLineHtml(salePrice, currencyCodeEnabled, false, root);
    }

    removeSaleBadges(root);
    ensureOffBadge(root, cfg);

    if (cfg.note && showNote && !getBadgeText(cfg) && !root.querySelector('.facett-price__note')) {
      var noteWrap = document.createElement('p');
      noteWrap.className = 'facett-price__note small mb-0 mt-2';
      noteWrap.innerHTML =
        '<a href="' + cfg.collectionPath + '/" class="facett-price__note-link text-decoration-none" style="color: #C5A66E;">' +
        '<i class="bi bi-tag-fill pe-1" aria-hidden="true"></i>' + cfg.note + '</a>';
      root.appendChild(noteWrap);
    }
  }

  function shouldSkipRoot(root) {
    return !!(root.closest('cart-drawer') || root.closest('.cart-item') || root.closest('table'));
  }

  function upgradeLegacyPrices(cfg, handles) {
    var pageHandle = getProductHandleFromPage();

    document.querySelectorAll('.price').forEach(function (root) {
      if (shouldSkipRoot(root)) {
        return;
      }
      if (root.dataset.saleActive === 'true') {
        return;
      }
      if (root.hasAttribute('data-facett-price-root')) {
        return;
      }

      var handle = pageHandle || getProductHandleFromCard(root);
      if (!handle) {
        return;
      }

      if (!isProductSaleEligible(root, handles)) {
        return;
      }

      var showNote = !!(pageHandle && handle === pageHandle && root.classList.contains('price--large'));
      var variantPrice = null;

      if (pageHandle && handle === pageHandle && root.classList.contains('price--large')) {
        variantPrice = getCurrentVariantPriceCents();
      }

      root.dataset.facettProductHandle = handle;
      root.dataset.facettShowNote = showNote ? 'true' : 'false';
      root.dataset.currencyCodeEnabled = 'false';

      applySaleToRoot(root, cfg, {
        handles: handles,
        variantPriceCents: variantPrice,
        showNote: showNote
      });
    });
  }

  function initModernPrices(cfg, handles) {
    document.querySelectorAll('[data-facett-price-root]').forEach(function (root) {
      if (root.dataset.saleActive === 'true') {
        return;
      }

      if (!isProductSaleEligible(root, handles)) {
        return;
      }

      applySaleToRoot(root, cfg, {
        handles: handles,
        showNote: root.dataset.facettShowNote === 'true'
      });
    });
  }

  function onVariantChange(variant) {
    scheduleSaleRefresh(variant);
  }

  function bindPriceObservers() {
    document.querySelectorAll('.product [id^="price-"]').forEach(function (priceRoot) {
      var timer = null;
      var observer = new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          var idInput = document.querySelector('.product form[action*="/cart/add"] [name="id"]');
          if (!idInput || !idInput.value) {
            return;
          }
          refreshAllSalePrices({
            id: idInput.value,
            price: getCurrentVariantPriceCents()
          });
        }, 0);
      });
      observer.observe(priceRoot, { childList: true });
    });
  }

  function initSalePrices() {
    var cfg = getConfig();
    if (!cfg || !cfg.active || !cfg.percent) {
      return;
    }

    fetchSaleProductHandles(cfg).then(function (handles) {
      initModernPrices(cfg, handles);
      upgradeLegacyPrices(cfg, handles);
      normalizeAllTaxLabels();
      bindPriceObservers();
    });
  }

  function bindVariantInputs() {
    document.querySelectorAll('variant-selects, variant-radios').forEach(function (el) {
      el.addEventListener('change', function () {
        var productInfo = el.closest('product-info') || el.closest('.product');
        if (!productInfo) {
          return;
        }
        var selected = productInfo.querySelector('[data-selected-variant]');
        if (!selected) {
          return;
        }
        try {
          var variant = JSON.parse(selected.textContent);
          onVariantChange(variant);
        } catch (e) {
          /* noop */
        }
      });
    });

    document.addEventListener('change', function (event) {
      if (!event.target || event.target.name !== 'id') {
        return;
      }
      var productInfo = event.target.closest('product-info') || event.target.closest('.product');
      if (!productInfo || !productInfo.querySelector('.price.price--large, [data-facett-price-root]')) {
        return;
      }
      var selected = productInfo.querySelector('[data-selected-variant]');
      var variant = null;
      if (selected) {
        try {
          variant = JSON.parse(selected.textContent);
        } catch (e) {
          /* noop */
        }
      }
      if (!variant || !variant.id) {
        variant = { id: event.target.value, price: getCurrentVariantPriceCents() };
      }
      if (variant && variant.id) {
        onVariantChange(variant);
      }
    });

    document.addEventListener('facett:price-replaced', function (event) {
      if (event.detail && event.detail.variant) {
        onVariantChange(event.detail.variant);
      }
    });
  }

  document.addEventListener('variant:change', function (event) {
    if (event.detail && event.detail.variant) {
      onVariantChange(event.detail.variant);
    }
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      if (event && event.data && event.data.variant) {
        onVariantChange(event.data.variant);
      }
    });
  }

  function boot() {
    normalizeAllTaxLabels();
    initSalePrices();
    bindVariantInputs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
